import { Icon, IconProps } from './Icon';

export const SmartToolsPackingListIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      stroke="#222B3A"
      fill="none"
    >
      <path
        d="M4 9H20L19.165 18.181C19.1198 18.6779 18.8906 19.14 18.5222 19.4766C18.1538 19.8131 17.673 19.9998 17.174 20H6.826C6.32704 19.9998 5.84617 19.8131 5.4778 19.4766C5.10942 19.14 4.88016 18.6779 4.835 18.181L4 9Z"
        stroke="black"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
      <path
        d="M8 11V8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4C13.0609 4 14.0783 4.42143 14.8284 5.17157C15.5786 5.92172 16 6.93913 16 8V11"
        stroke="black"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  </Icon>
);
